import { useTranslation } from 'react-i18next';

export const PAGE_STATISTICS_TAB = 'page-statistics';
export const LINK_CLICKS_TAB = 'link-clicks';

const TABS = [
  { id: PAGE_STATISTICS_TAB, labelKey: 'linkClicks.pageStatisticsTab' },
  { id: LINK_CLICKS_TAB, labelKey: 'linkClicks.linkClicksTab' }
];

const MePageTabs = ({ activeTab, onTabChange }) => {
  const { t } = useTranslation();

  return (
    <nav
      className="border-bottom"
      aria-label={t('linkClicks.statisticsSections')}
    >
      <div className="nav gap-2" role="tablist">
        {TABS.map(({ id, labelKey }) => {
          const isActive = activeTab === id;

          return (
            <button
              key={id}
              id={`${id}-tab`}
              type="button"
              role="tab"
              aria-selected={isActive}
              aria-controls={`${id}-panel`}
              className={`me-page-tab px-3 pb-2 bg-transparent fs-6 ${
                isActive ? ' active fw-bold text-primary2' : ' text-gray'
              }`}
              onClick={() => onTabChange(id)}
            >
              {t(labelKey)}
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default MePageTabs;
